import React, { useState } from "react";
import "./Sidebar.css";
import { useNavigate, useLocation } from "react-router-dom";
import { useRolePermission } from "../../hooks/useRolePermission";

const arrowRight = "/icons/icons8-arrow-right-100.png";
const arrowDown = "/icons/icons8-arrow-down-100.png";

const Sidebar = () => {
  const [openMenu, setOpenMenu] = useState({
    requests: false,
    reports: false,
    queries: false,
  })

  const navigate = useNavigate();
  const location = useLocation();
  const { role } = useRolePermission(); // 2. Lấy role hiện tại
  const isActive = (path) => location.pathname.startsWith(path);
  const handleLogout = () => {
    localStorage.clear();
    navigate("/");
  };
  // --- LOGIC PHÂN QUYỀN MENU ---

  // 1. Menu "Yêu cầu của tôi": Chỉ BANK_CREATE (theo ảnh: dòng Xem yêu cầu của tôi)
  const showMyReq = role === "BANK_CREATE";

  // 2. Menu "Chờ xử lý": Admin và Approve (theo ảnh: dòng Xem yêu cầu chờ xử lý)
  const showPendingReq = role === "BANK_ADMIN" || role === "BANK_APPROVE";

  // 3. Hiển thị nhóm cha "PHIẾU YÊU CẦU" nếu có ít nhất 1 menu con được hiện
  const showRequestGroup = showMyReq || showPendingReq;
  return (
    <div className="sidebar">
      <div className="sidebar-menu">
        {/* GROUP 1 — QUẢN LÝ ĐẠI LÝ (Ai cũng xem được theo ảnh, trừ việc tạo/sửa xử lý bên trong trang) */}
        <div className="menu-group">
          <div
            className={`menu-parent no-toggle ${isActive("/app/agents") ? "active-parent" : ""}`}
            onClick={() => navigate("/app/agents")}
          >
            <span>QUẢN LÝ ĐẠI LÝ VÀ USER</span>
            <img src={arrowRight} alt="" className="arrow-icon" />
          </div>
        </div>
        {/* GROUP 2 — TRUY VẤN */}
        <div className="menu-group">
          <div
            className={`menu-parent ${isActive("/app/queries") ? "active-parent" : ""}`}
            onClick={() =>
              setOpenMenu({ ...openMenu, queries: !openMenu.queries })
            }
          >
            <span>TRUY VẤN</span>
            <img
              src={openMenu.queries ? arrowDown : arrowRight}
              alt=""
              className="arrow-icon"
            />
          </div>

          {openMenu.queries && (
            <div className="menu-child">

              {/* 1. HẠN MỨC ĐẠI LÝ */}
              <div
                className={`child-item ${isActive("/app/queries/agent-limit") ? "child-active" : ""
                  }`}
                onClick={() => navigate("/app/queries/agent-limit")}
              >
                Hạn mức đại lý
              </div>

              {/* 2. HẠN MỨC USER */}
              <div
                className={`child-item ${isActive("/app/queries/user-limit") ? "child-active" : ""
                  }`}
                onClick={() => navigate("/app/queries/user-limit")}
              >
                Hạn mức user
              </div>

              {/* 3. HẠN MỨC KHÁCH HÀNG */}
              <div
                className={`child-item ${isActive("/app/queries/customer-limit") ? "child-active" : ""
                  }`}
                onClick={() => navigate("/app/queries/customer-limit")}
              >
                Hạn mức khách hàng
              </div>

            </div>
          )}
        </div>

        {/* GROUP 3 — PHIẾU YÊU CẦU (ĐÃ SỬA LOGIC)
        {showRequestGroup && (
          <div className="menu-group">
            <div
              className={`menu-parent ${isActive("/app/requests") ? "active-parent" : ""}`}
              onClick={() =>
                setOpenMenu({ ...openMenu, requests: !openMenu.requests })
              }
            >
              <span>PHIẾU YÊU CẦU</span>
              <img
                src={openMenu.requests ? arrowDown : arrowRight}
                alt=""
                className="arrow-icon"
              />
            </div>

            {openMenu.requests && (
              <div className="menu-child">
                {/* Chỉ hiện nếu là CREATE */}
                {/* {showMyReq && (
                  <div
                    className={`child-item ${isActive("/app/requests/mine") ? "child-active" : ""}`}
                    onClick={() => navigate("/app/requests/mine")}
                  >
                    Yêu cầu của tôi
                  </div>
                )} */}

                {/* Chỉ hiện nếu là ADMIN hoặc APPROVE */}
                {/* {showPendingReq && (
                  <div
                    className={`child-item ${isActive("/app/requests/pending") ? "child-active" : ""}`}
                    onClick={() => navigate("/app/requests/pending")}
                  >
                    Chờ xử lý
                  </div>
                )} */}
              {/* </div> */}
            {/* )}
          </div> */}
        {/* )} */} 

        {/* GROUP 4 — BÁO CÁO (Ai cũng được xem, logic filter data xử lý ở trang báo cáo sau) */}
        <div className="menu-group">
          {/* ... (Giữ nguyên code phần Báo cáo) ... */}
          <div
            className={`menu-parent ${isActive("/app/reports") ? "active-parent" : ""
              }`}
            onClick={() =>
              setOpenMenu({ ...openMenu, reports: !openMenu.reports })
            }
          >
            <span>BÁO CÁO</span>
            <img
              src={openMenu.reports ? arrowDown : arrowRight}
              alt=""
              className="arrow-icon"
            />
          </div>

          {openMenu.reports && (
            <div className="menu-child">
              <div
                className={`child-item ${isActive("/app/reports/transactions") ? "child-active" : ""
                  }`}
                onClick={() => navigate("/app/reports/transactions")}
              >
                Giao dịch
              </div>
              <div
                className={`child-item ${isActive("/app/reports/revenue") ? "child-active" : ""
                  }`}
                onClick={() => navigate("/app/reports/revenue")}
              >
                Doanh số
              </div>
              {/* <div
                className={`child-item ${isActive("/app/reports/agents") ? "child-active" : ""
                  }`}
                onClick={() => navigate("/app/reports/agents")}
              >
                Đại lý
              </div> */}
            </div>
          )}
        </div>
      </div>
      {/* ===== LOGOUT PHÍA DƯỚI ===== */}
      <div className="sidebar-bottom">
        <div className="logout-item" onClick={handleLogout}>
          <img src="/icons/icons8-logout-100.png" className="logout-icon" />
          <span>Đăng xuất</span>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
